const HYPGRAPH_MEDIA_REGX = /^https:\/\/media.graphassets.com\//;

const WIDTH = 1200;
const HEIGHT = 630;

export const resizeImage = (
  imageUrl: string,
  width = WIDTH,
  height = HEIGHT,
) => {
  if (!HYPGRAPH_MEDIA_REGX.test(imageUrl)) {
    return imageUrl;
  }

  const [protocol, , domain, ...rest] = imageUrl.split('/');
  return `${protocol}//${domain}/resize=fit:crop,width:${width},height:${height}/${
    rest[rest.length - 1]
  }`;
};
